import { transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { GroupedVoyageValidationErrorModel, VoyageValidationTypesEnum } from "../../../../../../models/vetting/vetting.models";
import {
    NotificationClientService,
    NotificationType
} from "../../../../../../services/basics/notification-client.service";
import { VoyageDataSubmissionService } from "../../../../../../services/vetting/voyage-data-submission.service";
import { I18N } from "aurelia-i18n";
import { EntityTypeConfigurationModel, EntityTypeConfigurationHelper } from "../../../../../../models/basics/basics.models";

@transient()
export class VoyageDataValidationErrorsDialog {

    public validationErrors: GroupedVoyageValidationErrorModel[] = [];

    private errorResolutions: {groupIdentifier: string, value: number, validationTypeId: number}[] = [];
    public currentContext: VoyageDataValidationErrorsDialog = this;

    public vesselEntityTypes: EntityTypeConfigurationModel[];

    private onSubmit: () => void;

    private customerId: number;

    private voyageDataSubmissionId: number;

    constructor(protected notificationsService: NotificationClientService, private i18N: I18N, private voyageDataSumisionService: VoyageDataSubmissionService,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper, private dialogClientService: DialogClientService)
    {
        this.vesselEntityTypes = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions(["AllVesselSearch"]).filter(x => x.key == "AllVesselSearch");
    }

    activate(model: { validationErrors: GroupedVoyageValidationErrorModel[], onSubmit: () => void, customerId: number, voyageDataSubmissionId: number })
    {
        this.validationErrors = model.validationErrors;
        this.onSubmit = model.onSubmit;
        this.customerId = model.customerId;
        this.voyageDataSubmissionId = model.voyageDataSubmissionId;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    canbeResolved(validationError: GroupedVoyageValidationErrorModel)
    {
        const canBeSolvedTypes = [VoyageValidationTypesEnum.Port, VoyageValidationTypesEnum.Vessel, VoyageValidationTypesEnum.CargoType, VoyageValidationTypesEnum.FuelType];
        if(canBeSolvedTypes.indexOf(validationError.validationTypeId) > -1)
        {
            return true;
        }
        return false;
    }

    resolutionHtml(validationError: GroupedVoyageValidationErrorModel)
    {
        let html = ``;
        if(validationError.validationTypeId == VoyageValidationTypesEnum.Port)
        {
            html = `<div class="row">`;
            html += `<lookup-control class="error-input" no-item-option-label=' ' label="Country" `
            html += `placeholder='Select Country' show-on-adorner.bind='true' query='RS_Countries' selected-value.two-way='countryId'></lookup-control>`;
            html += `<lookup-control class="error-input port" no-item-option-label=' ' label="Port" selected-value-changed.delegate='currentContext.updateErrorResolution($event.detail.value, validationError.groupIdentifier, validationError.validationTypeId)' `
            html += `<lookup-control class="error-input port" no-item-option-label=' ' label="Port" selected-value-changed.delegate='currentContext.updateErrorResolution($event.detail.value, validationError.groupIdentifier, validationError.validationTypeId)' `
            html += `query="RS_Ports" selected-value.two-way="portId" parameters="\${countryId},\${true}" placeholder="Select port" if.bind="countryId"></lookup-control>`;
            html += `</div>`;
        }
        else if(validationError.validationTypeId == VoyageValidationTypesEnum.Vessel)
        {
            html = `<div class="row">`;
            html += 
            `<entity-finder-search class="error-input" show-on-adorner.bind="false" show-close.bind="true"
                min-search-length.bind="3" auto-select-result.bind="false" show-view-more.bind="false" clear-filter-on-search.bind="false"
                data-id.bind="vesselId" supported-entity-types.bind="vesselEntityTypes" check-for-permission.bind="false"
                item-selected.delegate="currentContext.updateErrorResolution($event.detail.selectedEntity.id, validationError.groupIdentifier, validationError.validationTypeId)"
                allow-selection.bind="true" label="Vessel" disable-search-popup.bind="true" placeholder="Search for a vessel name, IMO, VIN or ENI number">
            </entity-finder-search>`;
            html += `</div>`;
        }
        else if(validationError.validationTypeId == VoyageValidationTypesEnum.CargoType)
        {
            html = `<div class="row">`;
            html += `<lookup-control class="error-input" no-item-option-label=' ' label="Cargo Type" selected-value-changed.delegate='currentContext.updateErrorResolution($event.detail.value, validationError.groupIdentifier, validationError.validationTypeId)' `
            html += `query="RS_CargoTypes" selected-value.two-way="cargoTypeId" placeholder="Select Cargo Type"></lookup-control>`;
            html += `</div>`;
        }
        else if(validationError.validationTypeId == VoyageValidationTypesEnum.FuelType)
        {
            html = `<div class="row">`;
            html += `<lookup-control class="error-input" no-item-option-label=' ' label="Fuel Type" selected-value-changed.delegate='currentContext.updateErrorResolution($event.detail.value, validationError.groupIdentifier, validationError.validationTypeId)' `
            html += `query="RS_FuelTypes" selected-value.two-way="fuelTypeId" placeholder="Select Fuel Type" parameters="true"></lookup-control>`;
            html += `</div>`;
        }

        return html;
    }

    updateErrorResolution(value: number, groupIdentifier: string, validationTypeId: number)
    {
        if(groupIdentifier == null) console.warn("Idnetifier cannot be null");
        const index = this.errorResolutions.findIndex(x => x.groupIdentifier == groupIdentifier);
        if(value == null && index >= 0)
        {
            this.errorResolutions.splice(index, 1);
        }
        else if(value != null){
            if(index >= 0)
                this.errorResolutions[index].value = value;
            else
                this.errorResolutions.push({ groupIdentifier: groupIdentifier, value: value, validationTypeId: validationTypeId });
        }
    }

    resolveValidationErrors()
    {
        return new Promise<void>((resolve, reject) => {
            this.voyageDataSumisionService.resolveValidationErrors(this.errorResolutions, this.customerId, this.voyageDataSubmissionId)
                .then(() => {
                    this.onSubmit();
                    this.errorResolutions.splice(0, this.errorResolutions.length);
                    this.notificationsService.show(this.i18N.tr('success-text'), "Resolved Errors Queued", NotificationType.Success);
                    this.dialogClientService.hide();
                    resolve();
                }, e => { 
                    this.notificationsService.show(this.i18N.tr('error-text'), "Resolve Errors Failed", NotificationType.Error);
                    console.error(e);
                    reject();
                });
        });
    }
}
